"use client";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { TrendingUp } from "lucide-react";
import { Pie, PieChart, Tooltip } from "recharts";

export function Component({ data }) {
  const chartData = [
    { browser: "Buyer", visitors: data?.buyerCount, fill: "#0C5C63" },
    { browser: "Seller", visitors: data?.sellerCount, fill: "#14BE73" },
    {
      browser: "Buyer Agent",
      visitors: data?.buyerAgentCount,
      fill: "#B2BEB5",
    },
    { browser: "Seller Agent", visitors: data?.sellerAgentCount, fill: "" },
  ];

  return (
    <Card className="flex flex-col">
      <CardHeader>
        <CardTitle>Role Metrics</CardTitle>
        <CardDescription>
          Clients and Agents types on our platform
        </CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <div className="mx-auto aspect-square max-h-[250px]">
          <PieChart width={250} height={250}>
            <Tooltip />
            <Pie
              data={chartData}
              dataKey="visitors"
              nameKey="browser"
              innerRadius={60}
              outerRadius={100}
              fill="#8884d8"
              strokeWidth={0}
              label={({ cx, cy }) => (
                <text
                  x={cx}
                  y={cy}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  {data?.totalUserCount}
                  <tspan
                    x={cx}
                    y={cy + 20}
                    style={{
                      fill: "#888",
                      fontSize: "12px",
                      display: "block",
                    }}
                  >
                    Users
                  </tspan>
                </text>
              )}
            />
          </PieChart>
        </div>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm">
        <div className="flex items-center gap-2 font-medium leading-none">
          Based on user roles <TrendingUp className="h-4 w-4" />
        </div>
        {/* <div className="leading-none text-muted-foreground">
          Showing total visitors for the last 6 months
        </div> */}
      </CardFooter>
    </Card>
  );
}
